export const HeaderLayout = {
	classic: 'Classic',
	overlap: 'Overlap',
};
